/**
 * Click a product screenshot to open it full size.
 *
 * The screenshots carry the argument on this site, and at column width you cannot
 * read a labour line or a core due date. This lets someone actually inspect them.
 *
 * No dependencies. Uses <dialog> where available so focus and Escape are handled by
 * the browser, with a plain overlay fallback.
 */
(function () {
  'use strict';

  var dialog = null;
  var imgEl = null;
  var capEl = null;
  var lastFocus = null;

  function build() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'sw-zoom';
    dialog.innerHTML =
      '<button class="sw-zoom__close" type="button" aria-label="Close">&times;</button>' +
      '<figure class="sw-zoom__figure">' +
      '<img class="sw-zoom__img" alt="">' +
      '<figcaption class="sw-zoom__cap"></figcaption>' +
      '</figure>';
    document.body.appendChild(dialog);
    imgEl = dialog.querySelector('.sw-zoom__img');
    capEl = dialog.querySelector('.sw-zoom__cap');

    dialog.querySelector('.sw-zoom__close').addEventListener('click', close);
    // Clicking the backdrop closes; clicking the image itself does not.
    dialog.addEventListener('click', function (e) {
      if (!e.target.closest('.sw-zoom__figure')) close();
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });
  }

  function open(trigger) {
    build();
    var img = trigger.querySelector('img');
    if (!img) return;
    lastFocus = document.activeElement;
    // srcset gives the browser a small file at column width; force the big one here.
    imgEl.src = trigger.getAttribute('data-full') || img.currentSrc || img.src;
    imgEl.alt = img.alt || '';
    var cap = trigger.getAttribute('data-caption') || '';
    capEl.textContent = cap;
    capEl.hidden = !cap;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sw-frame--zoomable');
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = document.activeElement && document.activeElement.closest
      ? document.activeElement.closest('.sw-frame--zoomable')
      : null;
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });
})();
